import { InjectionToken } from '@angular/core'
import { saveAs } from 'file-saver';

/**
 * Type for SAVER InjectionToken
 */
export type Saver = (blob: Blob, filename?: string) => void

/**
 * InjectionToken to use as provider in AppModule
 */
export const SAVER = new InjectionToken<Saver>('saver')

/**
 * Factory for SAVER provider
 */
export function getSaver(): Saver {
    return saveAs;
}